const actions = {
  GET_TEAMGROUP_READ_BEGIN: 'GET_TEAMGROUP_READ_BEGIN',
  GET_TEAMGROUP_READ_SUCCESS: 'GET_TEAMGROUP_READ_SUCCESS',
  GET_TEAMGROUP_READ_ERR: 'GET_TEAMGROUP_READ_ERR',

  TEAMGROUPS_ADD_BEGIN: 'TEAMGROUPS_ADD_BEGIN',
  TEAMGROUPS_ADD_SUCCESS: 'TEAMGROUPS_ADD_SUCCESS',
  TEAMGROUPS_ADD_ERR: 'TEAMGROUPS_ADD_ERR',

  TEAMGROUP_DELETE_BEGIN: 'TEAMGROUP_DELETE_BEGIN',
  TEAMGROUP_DELETE_SUCCESS: 'TEAMGROUP_DELETE_SUCCESS',
  TEAMGROUP_DELETE_ERR: 'TEAMGROUP_DELETE_ERR',

  TEAMGROUP_UPDATE_BEGIN: 'TEAMGROUP_UPDATE_BEGIN',
  TEAMGROUP_UPDATE_SUCCESS: 'TEAMGROUP_UPDATE_SUCCESS',
  TEAMGROUP_UPDATE_ERR: 'TEAMGROUP_UPDATE_ERR',


  getteamgroupReadBegin: () => {
    return {
      type: actions.GET_TEAMGROUP_READ_BEGIN,
    };
  },

  getteamgroupReadSuccess: (data) => {
    return {
      type: actions.GET_TEAMGROUP_READ_SUCCESS,
      data,
    };
  },

  getteamgroupReadErr: (err) => {
    return {
      type: actions.GET_TEAMGROUP_READ_ERR,
      err,
    };
  },

  teamgroupAddBegin: () => {
    return {
      type: actions.TEAMGROUPS_ADD_BEGIN,
    };
  },

  teamgroupAddSuccess: (data) => {
    return {
      type: actions.TEAMGROUPS_ADD_SUCCESS,
      data,
    };
  },

  teamgroupAddErr: (err) => {
    return {
      type: actions.TEAMGROUPS_ADD_ERR,
      err,
    };
  },





  teamgroupDeleteBegin: () => {
    return {
      type: actions.TEAMGROUP_DELETE_BEGIN,
    };
  },

  teamgroupDeleteSuccess: (data) => {
    return {
      type: actions.TEAMGROUP_DELETE_SUCCESS,
      data,
    };
  },

  teamgroupDeleteErr: (err) => {
    return {
      type: actions.TEAMGROUP_DELETE_ERR,
      err,
    };
  },




  teamgroupUpdateBegin: () => {
    return {
      type: actions.TEAMGROUP_UPDATE_BEGIN,
    };
  },

  teamgroupUpdateSuccess: (data) => {
    return {
      type: actions.TEAMGROUP_UPDATE_SUCCESS,
      data,
    };
  },

  teamgroupUpdateErr: (err) => {
    return {
      type: actions.TEAMGROUP_UPDATE_ERR,
      err,
    };
  },





};

export default actions;
